import { api } from '@/core/helpers/axiosHelper';

export default {
   async postBoardStructure(body: FormData) {
      return await api
         .post('/import/board-structure', body, {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         })
         .then((response) => {
            return response.data;
         });
   },
};
